import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import Paper from '@mui/material/Paper'
import { CardAction } from '~/features/adv_account/CardAction'
import { CardBrandIcon } from '~/components/common/CardBrandIcon'
import { SimpleCircularProgress } from '~/components/common/SimpleCircularProgress'
import React from 'react'
import { PaymentMethodKind, type CardList } from '~/lib/types/AdvAccount'

type CardListProps = {
  cardList: CardList | undefined
  paymentMethod: PaymentMethodKind | null
  fetchData: () => Promise<void>
}

export const CardListTable = React.memo(({ cardList, paymentMethod, fetchData }: CardListProps) => {
  if (!cardList) return <SimpleCircularProgress />
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold' }}>カード情報</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>有効期限(月/年)</TableCell>
            <TableCell sx={{ fontWeight: 'bold' }}>カード操作</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cardList.cards.data.map((card) => (
            <TableRow key={card.id}>
              <TableCell>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    whiteSpace: 'nowrap',
                    fontVariantNumeric: 'tabular-nums',
                  }}
                >
                  ****-****-****-{card.last4}
                  <CardBrandIcon brand={card.brand} size={26} />
                </Box>
              </TableCell>
              <TableCell>
                <Box sx={{ fontVariantNumeric: 'tabular-nums' }}>
                  {card.expMonth.toString().padStart(2, '0')}/{card.expYear}
                </Box>
              </TableCell>
              <TableCell>
                <CardAction
                  card={card}
                  cardList={cardList}
                  paymentMethod={paymentMethod}
                  fetchData={async () => {
                    await fetchData()
                  }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
})
CardListTable.displayName = 'CardList'
